<template>
  <div
    class="navigation-children js-header-navigation-about"
    id="js-navigation-children-about"
    v-on:mouseover="open"
    v-on:mouseleave="close"
  >
    <div class="l-container l-container-padding">
      <div class="navigation-children-inner">
        <div class="navigation-children-title">
          <div class="navigation-children-title-main">会社情報</div>
          <div class="navigation-children-title-sub">ABOUT TABIKOBO</div>
        </div>
        <ul class="navigation-children-lists">
          <li
            class="navigation-children-lists-item"
            v-for="menu in menus"
            :key="menu.path"
          >
            <a :href="menu.path">{{ menu.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from "jquery";
import Menus from "@/mixins/aboutMenus.js";

export default {
  mixins: [Menus],
  computed: {
    menus: function () {
      return this.aboutTop.concat(this.aboutMenus);
    },
  },
  methods: {
    open: function () {
      jQuery(".js-header-navigation-about").addClass("is-open");
      jQuery("#js-navigation-children-about").eq(0).addClass("is-hover");
    },
    close: function () {
      jQuery(".js-header-navigation-about").removeClass("is-open");
      jQuery("#js-navigation-children-about").eq(0).removeClass("is-hover");
    },
  },
};
</script>
